module.exports = __webpack_public_path__ + "media/img/vca/bg-sponsor.old-743116bc28bc587313d868df2891d883.png";